import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
        // General
        'HOME': "Home",
        'LEGAL_NOTICES': "Legal notices",
        'TERMS_OF_USE': "Terms of use",
        'FAQ': "Frequently asked questions",
        'MEDIA': "Media",
        'MEDIAS': "Medias",
        'PHOTO': "Photo",
        'PHOTOS': "Photos",
        'LANGUAGE': "Language",
        'SUPPLIERS': "Food suppliers",
        'PRESS_TITLE': "They're talking about us",
        'FOLLOW_US': "Follow us",
        'COPYRIGHT': 'All rights reserved. Website developed by Kubuni.',
        'DETAILS': 'Details',
        'SEND': "Send",
        "ERROR_MESSAGE": "An error occured.",
        "PASSWORD": "Password",
        "EMAIL_ADDRESS": "Email address",
        "ADDRESS": "Address",
        'SHOW': "View",
        "CANCEL": "Cancel",
        "CONFIRM": "Confirm",
        'EDIT': 'Edit',
        'SAVE': 'Save',
        'MANAGE_MEDIAS': 'Manage medias',
        'UPDATE': 'Update',
        'ADD': "Add",
        "LABEL": "Label",
        "URL": "URL",

        // Resto
        "OPENING": "Days and hours",
        "ACCESS": "Location & Access",

        // Confirm  
        "CONFIRM_DELETE": "Delete Confirmation",
        "CONFIRM_DELETE_MESSAGE": "Do you want to confirm deletion?",
        "COOKIE_CONSENT_MESSAGE": "We use cookies to enhance your experience on our site. By continuing, you agree to our use of cookies.",
        "I_CONSENT": "I consent",

        // Page not found
        "PAGE_NOT_FOUND_TITLE": "Page Not Found",
        "PAGE_NOT_FOUND_MESSAGE": "Sorry, the page you are looking for does not exist.",

        // Error component
        "ERROR_MESSAGE_API_GET": "An error occurred while retrieving data",
        "ERROR_MESSAGE_API_POST": "An error occurred while sending data",
        "ERROR_MESSAGE_API_UPDATE": "An error occurred while updating data",

        // Success messages
        "SUCCESS_CREATED_MESSAGE": "Creation was successful",
        "SUCCESS_UPDATED_MESSAGE": "Update was successful",
        "SUCCESS_DELETED_MESSAGE": "Deletion was successful",

        // Pending messages
        "PENDING_CREATED_MESSAGE": "Creation is being recorded",
        "PENDING_UPDATED_MESSAGE": "Update is being recorded",
        "PENDING_DELETED_MESSAGE": "Deletion is being recorded",
        "PENDING_LOAD_MESSAGE": "Loading...",

        // Login
        'LOGIN_EMAIL': "eMail",
        'LOGIN_EMAIL_PLACEHOLDER': "Enter email",
        'LOGIN_PASSWORD': "Password",
        'LOGIN_PASSWORD_PLACEHOLDER': "Enter password",
        'LOGIN_SUBMIT': "Login",
        'LOGIN_LOGIN': "Login",
        'LOGIN_INVALID_CREDENTIALS': "Invalid username or password. Please try again.",
        "CAPTCHA_ERROR": "Please check the box.",
    }
  },
  fr: {
    translation: {
        // General
        'HOME': "Accueil",
        'LEGAL_NOTICES': "Mentions légales",
        'TERMS_OF_USE': "Conditions générales d'utilisation",
        'FAQ': "Foire aux questions",
        'MEDIA': "Media",
        'MEDIAS': "Medias",
        'PHOTO': "Photo",
        'PHOTOS': "Photos",
        'SUPPLIERS': "Nos fournisseurs",
        "PRESS_TITLE": "Ils parlent de nous",
        'LANGUAGE': "Langue",
        'FOLLOW_US': "Suivez-nous",
        'COPYRIGHT': 'Tous droits réservés. Site développé par Kubuni',
        'DETAILS': 'Détails',
        'SEND': "Envoyer",
        "ERROR_MESSAGE": "Une erreur s'est produite.",
        'ADD': "Ajouter",
        'EDIT': "Mettre à jour",
        'SAVE': 'Enregistrer',
        'SHOW': "Voir",
        "CANCEL": "Annuler",
        "CONFIRM": "Confirmer",
        'MANAGE_MEDIAS': 'Gérer les medias',
        'UPDATE': 'Mettre à jour',
        "LABEL": "Libellé",
        "URL": "URL",

        // Resto
        "OPENING": "Jours et heures de service",
        "ACCESS": "Situation & Accès",

        // Confirm  
        "CONFIRM_DELETE": "Confirmation de suppression",
        "CONFIRM_DELETE_MESSAGE": "Souhaitez-vous confirmez la suppression ?",
        "COOKIE_CONSENT_MESSAGE": "Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant, vous acceptez notre utilisation des cookies.",
        "I_CONSENT": "J'accepte",

        // Page not found
        "PAGE_NOT_FOUND_TITLE": "Page non trouvée",
        "PAGE_NOT_FOUND_MESSAGE": "Désolé, la page recherchée n'existe pas.",
        
        // Error component
        "ERROR_MESSAGE_API_GET": "Une erreur s'est produite lors de la récupération des données",
        "ERROR_MESSAGE_API_POST": "Une erreur s'est produite lors de l'envoi des données",
        "ERROR_MESSAGE_API_UPDATE": "Une erreur s'est produite lors de la mise à jour des données",

        // Success messages
        "SUCCESS_CREATED_MESSAGE": "La création s'est effectuée avec succès",
        "SUCCESS_UPDATED_MESSAGE": "La mise à jour s'est effectuée avec succès",
        "SUCCESS_DELETED_MESSAGE": "La suppression s'est effectuée avec succès",

        // Pending message
        "PENDING_CREATE_MESSAGE": "La création est en cours d'enregistrement",
        "PENDING_UPDATE_MESSAGE": "La mise à jour est en cours d'enregistrement",
        "PENDING_DELETE_MESSAGE": "La suppression est en cours d'enregistrement",
        "PENDING_LOAD_MESSAGE": "Chargement en cours ...",

        // Login
        'LOGIN_EMAIL': "e-mail",
        'LOGIN_EMAIL_PLACEHOLDER': "Saisir votre e-mail",
        'LOGIN_PASSWORD': "Mot de passe",
        'LOGIN_PASSWORD_PLACEHOLDER': "Saisir votre mot de passe",
        'LOGIN_SUBMIT': "Connexion",
        'LOGIN_LOGIN': "Connexion",
        'LOGIN_INVALID_CREDENTIALS': "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer.",
        "CAPTCHA_ERROR": "Veuillez cocher la case.",

        // Statistics
        'DESKTOP': "PC/PC portable",
        'TABLET': "Tablette",
        'MOBILE': "Smartphone",

        'BING': "Bing",
        'DIRECT': "Accès direct",
        'FACEBOOK': "Facebook",
        'GOOGLE': "Google",
        'INSTAGRAM': "Instagram",
        'OTHER': "Autre",
        'TRIPADVISOR': "TripAdvisor",
        'TWITTER': "Twitter",
        'WIKIPEDIA': "Wikipédia",
        'YAHOO': "Yahoo",
        'YOUTUBE': "YouTube",
    }
  },
  es: {
    translation: {
        // General
        'HOME': "Inicio",
        'LEGAL_NOTICES': "Avisos legales",
        'TERMS_OF_USE': "Condiciones de uso",
        'FAQ': "Preguntas frecuentes",
        'MEDIA': "Media",
        'MEDIAS': "Medias",
        'PHOTO': "Foto",
        'PHOTOS': "Fotos",
        'SUPPLIERS': "Proveedores",
        'PRESS_TITLE': "Están hablando de nosotros",
        'LANGUAGE': "Idioma",
        'FOLLOW_US': "Síguenos",
        'COPYRIGHT': 'Todos los derechos reservados. Sitio web desarrollado por Kubuni.',
        'DETAILS': 'Detalles',
        'SEND': "Enviar",
        "ERROR_MESSAGE": "Se ha producido un error.",
        "PASSWORD": "Contraseña",
        "EMAIL_ADDRESS": "Dirección de correo electrónico",
        "ADDRESS": "Dirección",
        'SHOW': "Ver",
        "CANCEL": "Cancelar",
        "CONFIRM": "Confirmar",
        'EDIT': 'Editar',
        'SAVE': 'Guardar',
        'MANAGE_MEDIAS': 'Administrar fotos',
        'UPDATE': 'Actualizar',
        'ADD': "Añadir",
        "LABEL": "Etiqueta",
        "URL": "URL",

        // Resto
        "OPENING": "Días y horarios",
        "ACCESS": "Ubicación y Acceso",

        // Confirm  
        "CONFIRM_DELETE": "Confirmación de eliminación",
        "CONFIRM_DELETE_MESSAGE": "¿Desea confirmar la eliminación?",
        "COOKIE_CONSENT_MESSAGE": "Utilizamos cookies para mejorar su experiencia en nuestro sitio. Al continuar, acepta nuestro uso de cookies.",
        "I_CONSENT": "Consiento",

        // Page not found
        "PAGE_NOT_FOUND_TITLE": "Página no encontrada",
        "PAGE_NOT_FOUND_MESSAGE": "Lo siento, la página que busca no existe.",

        // Error component
        "ERROR_MESSAGE_API_GET": "Se ha producido un error al recuperar datos",
        "ERROR_MESSAGE_API_POST": "Se ha producido un error al enviar datos",
        "ERROR_MESSAGE_API_UPDATE": "Se ha producido un error al actualizar datos",

        // Success messages
        "SUCCESS_CREATED_MESSAGE": "La creación fue exitosa",
        "SUCCESS_UPDATED_MESSAGE": "La actualización fue exitosa",
        "SUCCESS_DELETED_MESSAGE": "La eliminación fue exitosa",

        // Pending messages
        "PENDING_CREATED_MESSAGE": "La creación se está registrando",
        "PENDING_UPDATED_MESSAGE": "La actualización se está registrando",
        "PENDING_DELETED_MESSAGE": "La eliminación se está registrando",
        "PENDING_LOAD_MESSAGE": "Cargando...",

        // Login
        'LOGIN_EMAIL': "Correo electrónico",
        'LOGIN_EMAIL_PLACEHOLDER': "Introducir correo electrónico",
        'LOGIN_PASSWORD': "Contraseña",
        'LOGIN_PASSWORD_PLACEHOLDER': "Introducir contraseña",
        'LOGIN_SUBMIT': "Iniciar sesión",
        'LOGIN_LOGIN': "Iniciar sesión",
        'LOGIN_INVALID_CREDENTIALS': "Usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.",
        "CAPTCHA_ERROR": "Por favor, marque la casilla.",
    }
  },
  de: {
    translation: {
        // General
        'HOME': "Startseite",
        'LEGAL_NOTICES': "Rechtliche Hinweise",
        'TERMS_OF_USE': "Nutzungsbedingungen",
        'MEDIA': "Media",
        'MEDIAS': "Medias",
        'PHOTO': "Foto",
        'PHOTOS': "Fotos",
        'FAQ': "Häufig gestellte Fragen",
        'SUPPLIERS': "Lebensmittel-Lieferanten",        
        "PRESS_TITLE": "Über uns wird gesprochen",
        'LANGUAGE': 'Sprache',
        'FOLLOW_US': "Folge uns",
        'COPYRIGHT': 'Alle Rechte vorbehalten. Website entwickelt von Kubuni.',
        'DETAILS': 'Details',
        'SEND': "Senden",
        "ERROR_MESSAGE": "Ein Fehler ist aufgetreten.",
        "PASSWORD": "Passwort",
        "EMAIL_ADDRESS": "E-Mail-Addresse",
        "ADDRESS": "Adresse",
        'SHOW': "Anzeigen",
        "CANCEL": "Abbrechen",
        "CONFIRM": "Bestätigen",
        'EDIT': 'Bearbeiten',
        'SAVE': 'Speichern',
        'MANAGE_MEDIAS': 'Fotos verwalten',
        'UPDATE': 'Aktualisieren',
        'ADD': "Hinzufügen",
        "LABEL": "Bezeichnung",
        "URL": "URL",

        // Resto
        "OPENING": "Tage und Stunden",
        "ACCESS": "Lage & Zugang",

        // Confirm  
        "CONFIRM_DELETE": "Löschbestätigung",
        "CONFIRM_DELETE_MESSAGE": "Möchten Sie die Löschung bestätigen?",
        "COOKIE_CONSENT_MESSAGE": "Wir verwenden Cookies, um Ihr Erlebnis auf unserer Website zu verbessern. Durch die weitere Nutzung stimmen Sie unserer Verwendung von Cookies zu.",
        "I_CONSENT": "Ich stimme zu",

        // Page not found
        "PAGE_NOT_FOUND_TITLE": "Seite nicht gefunden",
        "PAGE_NOT_FOUND_MESSAGE": "Entschuldigung, die von Ihnen gesuchte Seite existiert nicht.",

        // Error component
        "ERROR_MESSAGE_API_GET": "Beim Abrufen der Daten ist ein Fehler aufgetreten",
        "ERROR_MESSAGE_API_POST": "Beim Senden der Daten ist ein Fehler aufgetreten",
        "ERROR_MESSAGE_API_UPDATE": "Beim Aktualisieren der Daten ist ein Fehler aufgetreten",

        // Success messages
        "SUCCESS_CREATED_MESSAGE": "Die Erstellung war erfolgreich",
        "SUCCESS_UPDATED_MESSAGE": "Die Aktualisierung war erfolgreich",
        "SUCCESS_DELETED_MESSAGE": "Die Löschung war erfolgreich",

        // Pending messages
        "PENDING_CREATED_MESSAGE": "Die Erstellung wird aufgezeichnet",
        "PENDING_UPDATED_MESSAGE": "Die Aktualisierung wird aufgezeichnet",
        "PENDING_DELETED_MESSAGE": "Die Löschung wird aufgezeichnet",
        "PENDING_LOAD_MESSAGE": "Laden...",

        // Login
        'LOGIN_EMAIL': "E-Mail",
        'LOGIN_EMAIL_PLACEHOLDER': "E-Mail eingeben",
        'LOGIN_PASSWORD': "Passwort",
        'LOGIN_PASSWORD_PLACEHOLDER': "Passwort eingeben",
        'LOGIN_SUBMIT': "Anmelden",
        'LOGIN_LOGIN': "Anmelden",
        'LOGIN_INVALID_CREDENTIALS': "Ungültiger Benutzername oder ungültiges Passwort. Bitte versuchen Sie es erneut.",
        "CAPTCHA_ERROR": "Bitte aktivieren Sie das Kontrollkästchen.",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
